import { API_URL, API_PAPU_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

let request = () => (axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
}))

/**
 * Clase para ver el request de sitios
 */
class UsuariosRequest {
    /**
     * Llamada el endpoint de django crear usuarios
     * @param: nada
     * @return: nada
     */
    static CrearUsuariosAuth() {
        return middleware.hasAuth(() => request().post(`api/usuarios/`))
    }

    /**
     * Llamada el endpoint de django para obtener los usuarios
     * en la BD
     * @param: nada
     * @return: Una lista de usuarios.
     */
    static ListarUsuarios(filtros) {
        return middleware.hasAuth(() => request().get(`api/usuarios/`, {
            params: {
                nombre: filtros.nombre,
                plaza: filtros.plaza,
                rol: filtros.rol,
                estatus: filtros.estatus,
                page: filtros.page,
                segmento: filtros.segmento
            }
        }))
    }

    /**
     * Llamada el endpoint de django para configurar un usuario
     * @param: value. id de usuario
     * @param: data. una lista de objetos que contiene datos del usuario
     * @return: Mensaje de éxito o error.
     */
    static ConfigurarUsuario(value,data) {
        return middleware.hasAuth(() => request().put(`api/usuarios/${value}/`, data));
    }

    /** ----------------------------------PAPU------------------------------------------  */

    /**
     * Llamada al endpoint de django para obtener los sitios que tiene asignado un usuario
     * en la BD de papu.
     * @param: id_auth. id del usuario de caffenio auth
     * @return: nada
     */
    static CargarSitiosUsuario(id_auth, valor=undefined){
        return middleware.hasAuth(() => request().get(`${API_PAPU_URL}/api/get_sitios_by_usuario/${id_auth}`,{
            'params': {
                'proveedores': typeof valor !== 'undefined' ? valor : undefined
            }
        }));
    }
}

export default UsuariosRequest;